import { z } from 'zod';

/** Fixed vehicle-board stages (BR-SO-203). */
export const YARD_STAGES = [
  'SCHEDULED',
  'CHECK_IN',
  'QUOTE',
  'SERVICE_ORDER',
  'CHECKOUT',
  'CASHIER',
  'DELIVERED',
] as const;

export const YardStageSchema = z.enum(YARD_STAGES);
export type YardStage = z.infer<typeof YardStageSchema>;
